import React from 'react';
import { useSportUrlParams } from '@mwl/core-lib';
import { CountriesAndTournamentsFilter } from '../CountriesAndTournamentsFilter/CountriesAndTournamentsFilter';
import { UpcomingFilter } from '../UpcomingFilter/UpcomingFilter';
import styles from './FiltersGroup.module.scss';
export const FiltersGroup = () => {
  const {
    stage
  } = useSportUrlParams();
  return <div className={styles.root} data-sentry-component="FiltersGroup" data-sentry-source-file="FiltersGroup.tsx">
      {stage === 'PREGAME' && <UpcomingFilter />}
      <CountriesAndTournamentsFilter data-sentry-element="CountriesAndTournamentsFilter" data-sentry-source-file="FiltersGroup.tsx" />
    </div>;
};